import Navigation from '@pelckmans/elementis/components/navigation';
import PelckmansIcon from '@pelckmans/elementis/icons/pelckmans';
import { useTranslation } from 'react-i18next';
import { useRoutes } from '../../../hooks/useRoutes';

function PelckmansLogo() {
  const { buildAbsolutePath } = useRoutes();

  const { t } = useTranslation();

  return (
    <Navigation aria-label={t('APP_NAV.SIDE_NAV.HOME_NAVIGATION.A11Y_LABEL')}>
      <Navigation.List>
        <Navigation.Item
          icon={<PelckmansIcon data-testid="pelckmans-icon" />}
          iconOnly
          to={buildAbsolutePath(['MY_METHODS', 'MY_METHODS.DASHBOARD'])}
        >
          {t('APP_NAV.SIDE_NAV.HOME')}
        </Navigation.Item>
      </Navigation.List>
    </Navigation>
  );
}

export default PelckmansLogo;
